import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  VertTypography, Row, Col,
} from '@vertem-core/vertice-ds';

import Scope from './Lang/Scope';
import ServicesBannersForHome from '../../components/ServicesBannersForHome';
import DropdownProductFeatures from '../../components/DropdownProductFeatures';
import Container from '../../Shared/common/components/Container';
import formatDetailsFeaturesToItemsDropdown from 'Utils/formatDetailsFeaturesToItemsDropdown';

const AboutPage = () => (
  <Row>
    <Col span={24}>
      <VertTypography.Title>
        <FormattedMessage {...Scope.title} />
      </VertTypography.Title>
    </Col>
    <Col span={24}>
      <VertTypography.Paragraph>
        <FormattedMessage {...Scope.content} />
      </VertTypography.Paragraph>
    </Col>
    <Col sm={24}>
      <ServicesBannersForHome banners={[
        {
          image: '/assets/images/f1.png',
          responsive: {
            xl: '',
            md: '',
            sm: '',
            xs: '',
          },
          link: '/',
        },
        {
          image: '/assets/images/f2.png',
          link: '/',
        },
        {
          image: '/assets/images/f3.png',
          link: '/',
        },
        {
          image: '/assets/images/f4.png',
          link: '/',
        },
        {
          image: '/assets/images/f5.png',
          link: '/',
        },
      ]}
      />
    </Col>
    <Col span={24}>
      <Container>
        <DropdownProductFeatures
          items={formatDetailsFeaturesToItemsDropdown({
            description: (`
                <strong>Adicione mais inteligência e conforto ao seu sistema de automação Mibo Home.</strong>
                O sensor de temperatura e umidade AST 3001 é totalmente sem fio e possui a tecnologia ZigBee, garantindo maior vida útil da sua bateria e velocidade de funcionamento.
                <strong>Monitore a temperatura e a umidade de qualquer ambiente em tempo real.</strong>
                O hub irá ajustar a temperatura do ar-condicionado automaticamente conforme a temperatura medida pelo sensor. É clima perfeito dentro de casa, o ano todo, a toda hora!
                <strong>Histórico das leituras na palma de sua mão</strong>
                Além de toda segurança e velocidade nas automações da tecnologia ZigBee, você terá dados monitorados em tempo real, sabendo quando algo fora do padrão aconteceu.*Este sensor funciona exclusivamente com a linha de automação Mibo Home.
            `),
            features: [
              {
                name: 'Alcance do Sensor',
                value: '200 metros sem barreiras',
                type: 'ESPECIFICAÇÕES TÉCNICAS',
              },
              {
                name: 'Voltagem',
                value: 'Bivolt',
                type: 'ESPECIFICAÇÕES TÉCNICAS',
              },
              {
                name: 'Conexão',
                value: 'Sem fio (ZigBee)',
                type: 'CARACTERÍSTICAS',
              },
              {
                name: 'Quantidade de peças',
                value: '1',
                type: 'CARACTERÍSTICAS',
              },
              {
                name: 'Conteúdo da embalagem',
                value: '- 1 Sensor de temperatura e umidade- 1 Fita dupla face- 1 Guia de instalação',
                type: 'ESPECIFICAÇÕES TÉCNICAS',
              },
              {
                name: 'Observações',
                value: '<strong>- obrigatório o uso de um Hub compatível da linha de automação Mibo Home- o sensor de temperatura foi desenvolvido para uso interno</strong>',
                type: 'ESPECIFICAÇÕES TÉCNICAS',
              },
              {
                name: 'Alimentação',
                value: '3VDC, Bateria CR2032',
                type: 'ESPECIFICAÇÕES TÉCNICAS',
              },
              {
                name: 'Características gerais',
                value: '- Tecnologia zigbee- Sensor de temperatura- Sensor de umidade- Sensor de pressão atmosférica- Protocolo de comunicação sem fio: ZigBee- Frequência de operação: IEEE 802.15.4- Alcance da conexão ZigBee: 100 metros sem barreiras- Alimentação: 3VDC, Bateria CR2032- Corrente de operação: Repouso: 20uA Máximo: 40mA- Alarme de bateria “fraca”: Sim, através do APP Mibo Home- Precisão da temperatura: -20?~+50°C, ±0.3?- Precisão da umidade: 0 – 100% RH, ±3%- Temperatura de operação: -10? a +50?- Umidade de operação: 10% a 90% sem condensação',
                type: 'CARACTERÍSTICAS',
              },
              {
                name: 'Alimentação dos sensores',
                value: '3VDC, Bateria CR2032',
                type: 'ESPECIFICAÇÕES TÉCNICAS',
              },
              {
                name: 'Garantia',
                value: '12 meses',
                type: 'ESPECIFICAÇÕES TÉCNICAS',
              },
              {
                name: 'Angulação de fixação do sensor',
                value: 'Não se aplica',
                type: 'ESPECIFICAÇÕES TÉCNICAS',
              },
              {
                name: 'Fixação por',
                value: 'Fita dupla face',
                type: 'ESPECIFICAÇÕES TÉCNICAS',
              },
              {
                name: 'Ideial para:',
                value: 'Áreas internas',
                type: 'ESPECIFICAÇÕES TÉCNICAS',
              },
              {
                name: 'Entrega do Produto',
                value: 'Todas as instruções, manuais e peças necessárias para a montagem são fornecidas junto com o produto,não nos responsabilizamos pela instalação/montagem,orientamos que este produto seja montado por um técnico de sua confiança, após a sua entrega',
                type: 'ESPECIFICAÇÕES TÉCNICAS',
              },
            ],
          })}
        />
      </Container>
    </Col>
  </Row>
);

export default AboutPage;
